export enum WcagActionEnum {
  DATE_CHANGE,
  TIME_CHANGE,

  CINEMA_SELECTED,

  SEAT_SELECTED,
  SEAT_UNSELECTED,

  QUANTITY_CHANGE,
  QUANTITY_MIN_REACHED,
  QUANTITY_MAX_REACHED,

  ZOOM_IN,
  ZOOM_OUT,

  FORM_SUBMIT_SUCCESS,
  FORM_SUBMIT_ERROR,
  FIELD_VALIDATION_ERROR,

  DATA_LOADING_STARTED,
  DATA_LOADING_COMPLETED,
  DATA_LOADING_FAILED,

  ITEM_ADDED_TO_CART,
  ITEM_REMOVED_FROM_CART,

  // Specjalna akcja dla niestandardowych wiadomości
  CUSTOM_MESSAGE
}
